import { gql } from "@apollo/client";

const list = gql`
  query Query($filter: FilterFindManyContactInput, $skip: Int, $limit: Int) {
    contactCount
    contactMany(filter: $filter, skip: $skip, limit: $limit) {
      _id
      email
      emails
      firstName
      lastName
      contactOwner
      date
    }
  }
`;

const create = gql`
  mutation Mutation($record: CreateOneContactInput!) {
    contactCreateOne(record: $record) {
      recordId
    }
  }
`;

const createMany = gql`
  mutation Mutation($records: [CreateManyContactInput!]!) {
    contactCreateMany(records: $records) {
      createdCount
    }
  }
`;

const find = gql`
  query ContactById($id: MongoID!, $sortApplication: SortFindManyTalentInput) {
    contactById(_id: $id) {
      _id
      date
      companyAlias
      emails
      email
      firstName
      lastName
      contactOwner
      applications(sort: $sortApplication) {
        _id
        companyAlias
        listingId
        applicationId
        applicationDate
        listing {
          subscribed
          details
        }
        talentListingDistances {
          details
          summary
          priority
        }
        linkedinId
      }
    }
  }
`;

const tracker = gql`
  query EmailTrackerMany($filter: FilterFindManyEmailTrackerInput) {
    emailTrackerMany(filter: $filter) {
      mailId
      count
    }
  }
`;

export default {
  list,
  create,
  createMany,
  find,
  tracker,
};
